var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderDocumentList',{attrs:{"order":_vm.order},on:{"documentsCreated":_vm.onEventDocumentsCreated}})
}
var staticRenderFns = []

export { render, staticRenderFns }